var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"textWithHighlightComponent"},_vm._l((_setup.splitText),function(block,name,index){return _c('span',{key:index,class:_setup.isHighlightTerm(block) ? 'highlight' : '',domProps:{"textContent":_vm._s(block)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }